import { http } from 'shared/api/http';
import { endpoints } from 'shared/api/endpoints';

export function sendPlanRequest(payload) {
  return http(endpoints.abonelik.planTalep, {
    method: 'POST',
    body: payload, // ✅ OBJECT gönder
    // headers yazmana da gerek yok, http zaten body varsa Content-Type set ediyor
  });
}
